const FLAG_ERRO_NAO_MAPEADO = 'erro_nao_mapeado'

function validarProblema (item) {
  const possuiProblema = item && item.problematic
  const ehUmObjeto = typeof item.problematic === 'object'
  const possuiTodasAsChaves = ['verbo', 'mensagem', 'ultimaTentativaPor', 'ultimaTentativaEm'].every(key => Object.keys(item.problematic).includes(key))
  if (possuiProblema && ehUmObjeto && possuiTodasAsChaves) return
  throw Error('o objeto descritivo do problema com a aprovação não é válido')
}

function pegarMensagemDoProblemaTooltip (item) {
  if (item && !item.problematic) return
  validarProblema(item)
  const {verbo, mensagem} = item.problematic
  if (mensagem === FLAG_ERRO_NAO_MAPEADO) {
    return `Erro inesperado ao ${verbo} o pedido. Tente novamente ou entre em contato com o suporte`
  }
  return `Erro ao ${verbo} o pedido: ${mensagem}`
}

function pegarMensagemDoProblemaDetalhes (item) {
  if (item && !item.problematic) return
  validarProblema(item)
  const {verbo, mensagem, ultimaTentativaPor, ultimaTentativaEm} = item.problematic
  const detalhes = `última tentativa em ${ultimaTentativaEm} por (${ultimaTentativaPor})`
  if (mensagem === FLAG_ERRO_NAO_MAPEADO) {
    return {
      detalhes,
      observacao: `Erro inesperado ao ${verbo} o pedido. Tente novamente ou entre em contato com o suporte`
    }
  }
  return {
    detalhes,
    observacao: `Erro ao ${verbo} o pedido: ${mensagem}`
  }
}

export {
  pegarMensagemDoProblemaTooltip,
  pegarMensagemDoProblemaDetalhes
}
